import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberRides/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/memberRides/exportMemberRidesExcel', data, {
    trim: true,
    download: true
  })
}
// 强制还车
export function forceBack (data) {
  return request.post('/business/memberRides/forceBack', data)
}
// 修改骑行时长
export function updateDuration (data) {
  return request.post('/business/memberRides/updateDuration', data)
}
